export default {
	menu: {
		showPrice: true,
		online: true,
		offline: '',
	},
};
